module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Heavy.714149fe.otf";